import AdtInfoAddInstructionDialog from "./adtInfoAddInstructionDialog.container";

export default AdtInfoAddInstructionDialog;
